// extracted by mini-css-extract-plugin
export default {"error-indicator":"HosErrorIndicator_error-indicator__iEloX","card-wrapper":"HosErrorIndicator_card-wrapper__4EX83","card-message":"HosErrorIndicator_card-message__il4TX"};